import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import MultiSelector from "./MultiSelector"
import "./OfficeMultiSelector.css"
import Checkbox from "../Checkbox/Checkbox"

class OfficeMultiSelector extends PureComponent {
  renderOptions = () => {
    const { handleChange, options, filters } = this.props
    if (options) {
      return options.map(o => (
        <li key={o.value}>
          <Checkbox
            label={o.label}
            id={o.label}
            onClick={() => handleChange(o, "office")}
            checked={filters.some(f => f.value === o.value)}
          />
        </li>
      ))
    }
    return null
  }

  render() {
    const { handleChange, options, filters, ...rest } = this.props
    return (
      <div className="office-selector-wrapper">
        <MultiSelector
          text="Toimipaikka"
          filters={filters}
          filter="office"
          options={options}
          target="office"
          handleChange={handleChange}
          {...rest}
        >
          <ul>{this.renderOptions()}</ul>
        </MultiSelector>
      </div>
    )
  }
}

OfficeMultiSelector.propTypes = {
  toggleSelector: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  clearFilters: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape()),
}

export default OfficeMultiSelector
